import { isExtraComponent } from "../../hooks/useTesSalaryComponents";

export const formatSalary = (value: string): string => {
  if (isNaN(+value)) return value;
  const parsedValue = parseFloat(value).toFixed(2);
  return `${parsedValue.replace(".", ",")} €/h`;
};

export const calculateTotalSalary = (
  components: Record<string, string>,
): string => {
  const total = Object.keys(components).reduce((acc, key) => {
    if (!isExtraComponent(key)) {
      acc += parseFloat(components[key]) || 0;
    }
    return acc;
  }, 0);
  return formatSalary(total.toString());
};

export const calculateZonedTotalSalary = (
  zonedComponents: Record<string, Record<string, string>> | undefined,
): Record<string, string> | undefined => {
  if (!zonedComponents) return undefined;

  return Object.fromEntries(
    Object.entries(zonedComponents).map(([zone, components]) => [
      zone,
      calculateTotalSalary(components),
    ]),
  );
};
